export default (that) => [
  {
    field: 'seq',
    width: 50,
    align: 'center',
    type: 'seq',
  },
  {
    field: 'checkbox',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'checkbox',
    visible: that.multiple,
  },
  {
    field: 'radio',
    width: 40,
    align: 'center',
    fixed: 'left',
    type: 'radio',
    visible: !that.multiple,
  },
  {
    field: 'templateThumbnailUrl',
    width: 120,
    title: that.$l('INDEX.table_label_image') || '图片',
    align: 'center',
    slots: { default: 'templateThumbnailUrl' },
  },
  {
    field: 'templateNo',
    align: 'center',
    minWidth: 100,
    title: that.$l('table_label_templateNo') || '模板编号',
    showHeaderOverflow: true,
    showOverflow: true,
  },


  {
    field: 'templateName',
    headerAlign: 'center',
    align: 'left',
    minWidth: 200,
    title: that.$l('form_label_templateName') || '模板名称',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'templateStatus',
    headerAlign: 'center',
    align: 'center',
    width: 100,
    title: that.$l('INDEX.Status') || '模板状态',
    showHeaderOverflow: true,
    showOverflow: true,
    slots: { default: 'status' },
  },
  {
    field: 'templateType',
    headerAlign: 'center',
    align: 'left',
    minWidth: 100,
    title: that.$l('table_label_templateType') || '模板类型',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'templateGroup',
    headerAlign: 'center',
    align: 'left',
    minWidth: 150,
    title: that.$l('form_label_templateGroup') || '模版组',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'templateDesc',
    headerAlign: 'center',
    align: 'left',
    width: 250,
    title: that.$l('table_label_templateDesc') || '模板描述',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'templateFileType',
    headerAlign: 'center',
    align: 'left',
    width: 150,
    title: that.$l('table_label_templateFileType') || '模版文件类型',
    showHeaderOverflow: true,
    showOverflow: true,
  },
  {
    field: 'templateFileName',
    headerAlign: 'center',
    align: 'left',
    width: 250,
    title: that.$l('table_label_templateFileName') || '模板文件名称',
    showHeaderOverflow: true,
    showOverflow: true,
  },

  {
    field: 'createByName',
    title: that.$l('INDEX.table_label_creator') || '创建人',
    width: 100,
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: that.$l('INDEX.table_label_creator_date') || '创建时间',
    field: 'createTime',
    width: 170,
    align: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    field: 'modifyByName',
    title: that.$l('INDEX.table_label_modified_by') || '修改人',
    width: 100,
    headerAlign: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
  {
    title: that.$l('INDEX.table_label_modification_date') || '修改时间',
    field: 'modifyTime',
    width: 170,
    align: 'center',
    showHeaderOverflow: 'title',
    showOverflow: 'ellipsis',
  },
]
